module.exports = __webpack_public_path__ + "static/media/mokuroku-logo.cba9fbd4.svg";